export default __webpack_public_path__ + "static/media/new-tag.6338594c.png";